// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { AssessmentDiagnosisReviewRequest } from './assessment-diagnosis-review-request';

/** See com.rev360.pms.api.controller.encounter.assessment.CreateAssessmentDiagnosisReviewRequest */
/* istanbul ignore next */
@GandalfModel
export class CreateAssessmentDiagnosisReviewRequest extends AssessmentDiagnosisReviewRequest {

	@GandalfValidator({ sizeString: { message: 'Comments cannot be longer than 4000 characters', minLength: 0, maxLength: 4000 } })
	@GandalfProperty({ designType: String })
	comments!: string | null;

	@GandalfValidator({ notNull: { message: 'Encounter is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	encounterId!: number;

	@GandalfValidator({ notNull: { message: 'NoKnownDiagnoses is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	noKnownActiveDiagnoses!: boolean;

	@GandalfValidator({ notNull: { message: 'Patient is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	patientId!: number;

	@GandalfValidator({ notNull: { message: 'ReviewDate is required' } })
	@GandalfProperty({ designType: Date, isRequired: true })
	reviewDate!: Date;

}
